//#region Util Imports

import * as $ from 'jquery'

//#endregion

import { IReferenceType, IOpChangeState, IOpObject, IOpData } from '../util/interfaces'
import { Enums } from '../common/enums'
import { DataProvider } from '../../helpers/data-provider'
import { Dictionary } from '../../helpers/dictionary'
import { CommonHelper } from '../../helpers/common-helper'
import { ConvertHelper } from '../../helpers/convert-helper'

import { OpDataList } from '../util/op-data-list'
import { OpDataType } from './op-data-type'

import { OpActor } from './op-actor'
import { OpDistributor } from './op-distributor'
import { OpIssueData } from '../../models/core/op-issue-data'
import { OpIssueType } from './op-issue-type'
import { OpIssueStatus } from './op-issue-status'
import { OpLocation } from './op-location'
import { OpOperator } from './op-operator'
import { OpPriority } from './op-priority'
import { OpTask } from './op-task'

export class OpIssue implements IReferenceType, IOpObject, IOpChangeState {

    //Properties

    public idIssue: number
    public idActor: number
    public idOperatorRegistering: number
    public idOperatorPerformer: number
    public idIssueType: number
    public idIssueStatus: number
    public realizationDate: Date
    public creationDate: Date
    public shortDescr: string
    public longDescr: string
    public idLocation: number
    public deadline: Date
    public idPriority: number
    public rowVersion: number
    public idDistributor: number


    //Properties end


    //NavigationProperties

    public actor: OpActor
    public location: OpLocation
    public issueType: OpIssueType
    public issueStatus: OpIssueStatus
    public distributor: OpDistributor
    public priority: OpPriority
    public operatorRegistering: OpOperator
    public operatorPerformer: OpOperator

    //NavigationProperties end


    //CustomProperties

    public taskList: OpTask[] = [];

    //CustomProperties end


    constructor(opObj: any) {
        this.fromJSON(opObj)
    }


    //IOpChangeState implementation

    public opState: Enums.OpChangeState

    //IOpChangeState implementation end


    //IReferenceType implementation

    public getReferenceType(): Enums.ReferenceType {
        return Enums.ReferenceType.IdIssue
    }

    public getReferenceKey(): number {
        return this.idIssue
    }

    public getReferenceValue(): any {
        return this
    }

    //IReferenceType implementation end


    //IOpObject implementation

    public get idObject(): any {
        return this.idIssue
    }

    public set idObject(idObject: any) {
        this.idIssue = idObject
    }

    public dataList: OpDataList<OpIssueData> = new OpDataList<OpIssueData>(OpIssueData)

    public dynamicValues: { Key: string, Value: any }[] = []

    public customFormatString: string;

    public fromJSON(opObj: any, compressed: boolean = false): void {
        if (opObj == null) {
            this.idIssue = 0
            this.opState = Enums.OpChangeState.New
        } else {
            this.dynamicValues = opObj.dynamicValues;
            this.idIssue = opObj.ID_ISSUE
            this.idActor = opObj.ID_ACTOR
            this.idOperatorRegistering = opObj.ID_OPERATOR_REGISTERING
            this.idOperatorPerformer = opObj.ID_OPERATOR_PERFORMER
            this.idIssueType = opObj.ID_ISSUE_TYPE
            this.idIssueStatus = opObj.ID_ISSUE_STATUS
            this.realizationDate = opObj.REALIZATION_DATE ? ConvertHelper.stringToDate(opObj.REALIZATION_DATE) : null
            this.creationDate = opObj.CREATION_DATE ? ConvertHelper.stringToDate(opObj.CREATION_DATE) : null
            this.shortDescr = opObj.SHORT_DESCR
            this.longDescr = opObj.LONG_DESCR
            this.idLocation = opObj.ID_LOCATION
            this.deadline = opObj.DEADLINE ? ConvertHelper.stringToDate(opObj.DEADLINE) : null
            this.idPriority = opObj.ID_PRIORITY
            this.rowVersion = opObj.ROW_VERSION
            this.idDistributor = opObj.ID_DISTRIBUTOR
            this.opState = opObj.OpState

            if (opObj.DataList) {
                this.dataList.push(...opObj.DataList.map((data: Object) => new OpIssueData(data)))
            } else {
                this.dataList = new OpDataList<OpIssueData>()
            }

            if (opObj.TaskList) {
                this.taskList = opObj.TaskList.map(t => new OpTask(t))
            }

            if (opObj._Distributor) {
                this.distributor = new OpDistributor(opObj._Distributor)
            }

            if (opObj._IssueType) {
                this.issueType = new OpIssueType(opObj._IssueType)
            }

            if (opObj._Location) {
                this.location = new OpLocation(opObj._Location)
            }

            if (opObj._OperatorPerformer) {
                this.operatorPerformer = new OpOperator(opObj._OperatorPerformer)
            }

            if (opObj._OperatorRegistering) {
                this.operatorRegistering = new OpOperator(opObj._OperatorPerformer)
            }
        }
    }

    public toJSON(compressed: boolean = false): any {
        return {
            ID_ISSUE: this.idIssue,
            ID_ACTOR: this.idActor,
            ID_OPERATOR_REGISTERING: this.idOperatorRegistering,
            ID_OPERATOR_PERFORMER: this.idOperatorPerformer,
            ID_ISSUE_TYPE: this.idIssueType,
            ID_ISSUE_STATUS: this.idIssueStatus,
            REALIZATION_DATE: this.realizationDate ? ConvertHelper.dateToString(this.realizationDate, { netFormat: true }) : null,
            CREATION_DATE: this.creationDate ? ConvertHelper.dateToString(this.creationDate, { netFormat: true }) : null,
            SHORT_DESCR: this.shortDescr,
            LONG_DESCR: this.longDescr,
            ID_LOCATION: this.idLocation,
            DEADLINE: this.deadline ? ConvertHelper.dateToString(this.deadline, { netFormat: true }) : null,
            ID_PRIORITY: this.idPriority,
            ROW_VERSION: this.rowVersion,
            ID_DISTRIBUTOR: this.idDistributor,
            DataList: this.dataList ? this.dataList.ToJSON() : null,
            OpState: this.opState,
            TaskList: this.taskList ? this.taskList.map(tasks => tasks.toJSON()) : null,

        }
    }

    public toString() {
        let retVal: string = `[${this.idIssue}]`

        if (this.shortDescr != null) {
            retVal += ` ${this.shortDescr}`
        }

        return retVal
    }

    public toStringLongDescr() {
        let retVal: string = `[${this.idIssue}]`

        if (this.longDescr != null) {
            retVal += ` ${this.longDescr}`
        }

        return retVal
    }

    //IOpObject implementation end


    public static loadNavigationProperties(dataProvider: DataProvider, list: OpIssue[]): JQueryPromise<OpIssue[]> {
        const defered: JQueryDeferred<OpIssue[]> = $.Deferred<OpIssue[]>()
        if (dataProvider && list && list.length > 0) {
            let idDataType: number[] = CommonHelper.getIdDataTypesFromObjectList<OpIssue>(list)
            dataProvider.System.getDictionaries([Enums.ReferenceType.IdDataType]).then(dict => {
                let dataTypeDict: Dictionary<OpDataType> = new Dictionary<OpDataType>(null)
                if (dict.containsKey(Enums.ReferenceType.IdDataType)) {
                    dataTypeDict = <Dictionary<OpDataType>>dict.tryGetValue(Enums.ReferenceType.IdDataType)
                }

                list.forEach((item: OpIssue) => {
                    if (item.dataList) {
                        item.dataList
                            .toArray()
                            .forEach((data: OpIssueData) => {
                                data.dataType = dataTypeDict.tryGetValue(data.idDataType)
                            })
                    }
                })

                defered.resolve(list)
            })
        } else {
            defered.resolve(list)
        }

        return defered.promise()
    }

    public static fromIOpObject(object: IOpObject): OpIssue {
        const newObject: OpIssue = new OpIssue(null)

        newObject.idIssue = object.idObject
        newObject.opState = object.opState
        newObject.dataList.push(...object.dataList.toArray().map((d: IOpData) => OpIssueData.fromIOpData(d)))

        return newObject
    }

}